import React from 'react'
import PropTypes from 'prop-types'

import BasicViewComponent from './BasicViewComponent'
import Button from '@material-ui/core/Button'

class ActionButton extends BasicViewComponent {

  constructor (props) {
    super(props)

    this.icon = props.config.icon
    this.backgroundColor = props.config.backgroundColor
    this.backgroundImage = props.config.backgroundImage
    this.disableRipple = props.config.disableRipple || false
  }

  getStyle () {
    if (this.backgroundImage) {
      return {
        backgroundImage: this.backgroundImage,
        backgroundSize: 56
      }
    }
    else if (this.backgroundColor) {
      return {
        backgroundColor: this.backgroundColor
      }
    }
    return {}
  }

  render () {
    if (!super.conditionsAreMet()) {
      return null
    }

    return (
      <Button
        variant={'fab'}
        className={this.cssClass}
        style={this.getStyle()}
        onClick={this.onTouchTap}
        disableFocusRipple={this.disableRipple}
        disableRipple={this.disableRipple}
      >
        <img
          alt=''
          className={`${this.cssClass}_img`}
          src={this.icon} />
      </Button>
    )
  }

}

ActionButton.TYPE = 'actionButton'

ActionButton.propTypes = {
  config: PropTypes.object.isRequired
}

export default ActionButton



// WEBPACK FOOTER //
// ./src/components/ViewComponents/ActionButton.js